import { request } from "./http";
import type { Me, ProfilePatch, WorkspaceView } from "./types";

export const accountApi = {
  me: (signal?: AbortSignal) => request<Me>("GET", "/v1/me", undefined, { signal }),
  update: (patch: ProfilePatch) => request<Me>("PATCH", "/v1/me", patch),
  /** `version` is the one the person was shown; the API refuses it (TERMS_OUTDATED) if the Terms changed since. */
  acceptTerms: (version: string) => request<Me>("POST", "/v1/me/accept-terms", { version }),
  workspaces: () => request<{ workspaces: WorkspaceView[] }>("GET", "/v1/me/workspaces").then((r) => r.workspaces),
};
